<template>
  <div class="w-100" style="padding-right: 15px; padding-left: 15px;">
    <b-row>
      <b-col sm="12" md="12" lg="12" xl="12">
       <b-form-group
          label="Equipamento de lavagem automatizada*"
          label-for="id_equipamento_lavagem_automatizada"
        >
          <GenericSelect
            name="id_equipamento_lavagem_automatizada"
            labelKey="nome"
            :customFilters="{ ...options.filters, id_unidade: idUnidade }"
            disabledFirstOption
            route="equipamento"
            :disabled="isBusy"
            :state="validateState('id_equipamento_lavagem_automatizada')"
            v-validate="{ required: true }"
            v-model="id_equipamento_lavagem_automatizada"
            @input="onEquipamentoChange"
          />
        </b-form-group>
      </b-col>
      <b-col sm="12" md="12" lg="12" xl="12">
        <b-form-group
          label="Lote do equipamento*"
          label-for="lote"
          v-if="equipamentosUtilizamLote.includes(id_equipamento_lavagem_automatizada)"
        >
          <b-form-input
            name="lote"
            autocomplete="off"
            class="invision-input"
            :disabled="isBusy"
            v-validate="{ required: true }"
            :state="validateState('lote')"
            v-model="lote"
            @input="(v) => $emit('updateModel', { lote: v })"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import GenericSelect from '@/components/Form/GenericSelect';

export default {
  name: 'EquipamentoLimpezaAutomatizada',
  inject: ['validator', 'validateState'],
  created() {
    this.$validator = this.validator;
  },

  components: {
    GenericSelect,
  },

  data() {
    return {
      id_equipamento_lavagem_automatizada: null,
      lote: null,
    };
  },

  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
    idUnidade: {
      type: Number,
      required: true,
    },
  },

  computed: {
    equipamentosUtilizamLote() {
      return this.options.equipamentosComLote || [];
    },
  },

  mounted() {
    this.$emit('updateModel', { id_equipamento_lavagem_automatizada: this.id_equipamento_lavagem_automatizada });
  },

  methods: {
    onEquipamentoChange(value) {
      this.$emit('updateModel', { id_equipamento_lavagem_automatizada: value });

      if (!this.equipamentosUtilizamLote.includes(value)) this.lote = '';
    },
  },
};
</script>
